/**
 * AI Tool Names - Auto-generated from Go source
 *
 * DO NOT EDIT - This file is auto-generated by magefiles/internal/gen/gen.go
 * Source: internal/ai/tools/toolnames/toolnames.go
 *
 * To add a new tool name:
 *   1. Add the constant to internal/ai/tools/toolnames/toolnames.go
 *   2. Run 'mage gen:aiToolNames' to regenerate this file (or 'mage gen:all')
 *
 * The generator automatically extracts all constants with the "panther_ai_" prefix.
 */

export const ALERTS_ADD_COMMENT = 'panther_ai_alerts_add_comment';
export const ALERTS_ASSIGN = 'panther_ai_alerts_assign';
export const ALERTS_BULK_UPDATE = 'panther_ai_alerts_bulk_update';
export const ALERTS_GET = 'panther_ai_alerts_get';
export const ALERTS_LIST = 'panther_ai_alerts_list';
export const ALERTS_LIST_CONTEXT_TAGS = 'panther_ai_alerts_list_context_tags';
export const ALERTS_UPDATE = 'panther_ai_alerts_update';
export const CITATIONS_LIST = 'panther_ai_citations_list';
export const CLOUD_RESOURCES_GET = 'panther_ai_cloud_resources_get';
export const CLOUD_RESOURCES_GET_SAMPLE = 'panther_ai_cloud_resources_get_sample';
export const CLOUD_RESOURCES_LIST = 'panther_ai_cloud_resources_list';
export const CLOUD_RESOURCES_LIST_TYPES = 'panther_ai_cloud_resources_list_types';
export const CLOUD_SCANNING_DESCRIBE_POLICY = 'panther_ai_cloud_scanning_describe_policy';
export const CLOUD_SCANNING_DESCRIBE_RESOURCE = 'panther_ai_cloud_scanning_describe_resource';
export const CLOUD_SCANNING_GET_OVERVIEW = 'panther_ai_cloud_scanning_get_overview';
export const CLOUD_SCANNING_LIST_CIS_CONTROLS = 'panther_ai_cloud_scanning_list_cis_controls';
export const DATALAKE_ACTIVITY_HISTOGRAM = 'panther_ai_datalake_activity_histogram';
export const DATALAKE_EXECUTE_SAVED_QUERY = 'panther_ai_datalake_execute_saved_query';
export const DATALAKE_EXECUTE_SQL = 'panther_ai_datalake_execute_sql';
export const DATALAKE_GET_QUERY_RESULTS = 'panther_ai_datalake_get_query_results';
export const DATALAKE_GET_SAVED_QUERY = 'panther_ai_datalake_get_saved_query';
export const DATALAKE_LIST_SAVED_QUERIES = 'panther_ai_datalake_list_saved_queries';
export const DATALAKE_SEARCH_LOGS = 'panther_ai_datalake_search_logs';
export const DATALAKE_SUMMARIZE_COLUMN = 'panther_ai_datalake_summarize_column';
export const DATALAKE_WRITE_SAVED_QUERY = 'panther_ai_datalake_write_saved_query';
export const DESTINATIONS_LIST = 'panther_ai_destinations_list';
export const DETECTIONS_AUTHOR = 'panther_ai_detections_author';
export const DETECTIONS_CREATE = 'panther_ai_detections_create';
export const DETECTIONS_GET = 'panther_ai_detections_get';
export const DETECTIONS_GET_GLOBAL = 'panther_ai_detections_get_global';
export const DETECTIONS_LIST = 'panther_ai_detections_list';
export const DETECTIONS_LIST_GLOBALS = 'panther_ai_detections_list_globals';
export const DETECTIONS_TUNING_SKILL = 'panther_ai_detections_tuning_skill';
export const DETECTIONS_UPDATE = 'panther_ai_detections_update';
export const DETECTIONS_WRITER_SKILL = 'panther_ai_detections_writer_skill';
export const ENRICHMENTS_LOOKUP = 'panther_ai_enrichments_lookup';
export const LOG_SOURCES_GET_SAMPLE_DATA = 'panther_ai_log_sources_get_sample_data';
export const LOG_SOURCES_LIST = 'panther_ai_log_sources_list';
export const LOG_TYPES_GET_SCHEMA = 'panther_ai_log_types_get_schema';
export const LOG_TYPES_GUIDANCE_SKILL = 'panther_ai_log_types_guidance_skill';
export const LOG_TYPES_LIST = 'panther_ai_log_types_list';
export const LOG_TYPES_TEST_SCHEMA = 'panther_ai_log_types_test_schema';
export const LOG_TYPES_WRITER_SKILL = 'panther_ai_log_types_writer_skill';
export const MEMORY_GET_RESPONSE = 'panther_ai_memory_get_response';
export const MEMORY_SEARCH_RESPONSES = 'panther_ai_memory_search_responses';
export const NOTIFICATIONS_SLACK_LIST_CHANNELS = 'panther_ai_notifications_slack_list_channels';
export const NOTIFICATIONS_SLACK_MESSAGE_SKILL = 'panther_ai_notifications_slack_message_skill';
export const NOTIFICATIONS_SLACK_SEND_MESSAGE = 'panther_ai_notifications_slack_send_message';
export const PREFERENCES_GET = 'panther_ai_preferences_get';
export const ROLES_GET = 'panther_ai_roles_get';
export const ROLES_LIST = 'panther_ai_roles_list';
export const RUNBOOKS_AUTHOR = 'panther_ai_runbooks_author';
export const RUNBOOKS_RECORD_STEP_STATUS = 'panther_ai_runbooks_record_step_status';
export const SETTINGS_GET = 'panther_ai_settings_get';
export const SKILLS_AUTHOR = 'panther_ai_skills_author';
export const SKILLS_CREATE = 'panther_ai_skills_create';
export const USERS_GET = 'panther_ai_users_get';
export const USERS_LIST = 'panther_ai_users_list';
export const UTILITIES_ASK_QUESTION = 'panther_ai_utilities_ask_question';
export const UTILITIES_CALCULATE_RISK_SCORE = 'panther_ai_utilities_calculate_risk_score';
export const UTILITIES_CLASSIFICATION_ERROR_FIXER_SKILL =
  'panther_ai_utilities_classification_error_fixer_skill';
export const UTILITIES_FETCH_WEB = 'panther_ai_utilities_fetch_web';
export const UTILITIES_PANTHER_DOCS_SKILL = 'panther_ai_utilities_panther_docs_skill';
export const UTILITIES_PANTHER_FLOW_QUERY = 'panther_ai_utilities_pantherflow_query';
export const UTILITIES_PANTHER_FLOW_QUERY_SKILL = 'panther_ai_utilities_pantherflow_query_skill';
export const UTILITIES_SQL_QUERY_SKILL = 'panther_ai_utilities_sql_query_skill';
